import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const VyskaPneu = {
	name: NAME,
	apiProvider,
	router,
};
